import React, { useState } from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useAvailableRewards, useRedeemReward, useCustomerLookup } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Search, Gift, CheckCircle2 } from 'lucide-react';
export function LoyaltyRedemptionPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const [phoneSearch, setPhoneSearch] = useState('');
  const [activePhone, setActivePhone] = useState('');
  const {
    customer,
    loading: customerLoading
  } = useCustomerLookup(activePhone, restaurant.restaurant_id);
  const {
    rewards,
    loading: rewardsLoading,
    refetch
  } = useAvailableRewards(activePhone, restaurant.restaurant_id);
  const {
    redeem,
    loading: redeeming
  } = useRedeemReward();
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (phoneSearch.length >= 8) {
      setActivePhone(phoneSearch);
    }
  };
  const handleRedeem = async (rewardId: string) => {
    if (window.confirm('¿Estás seguro de redimir este beneficio? Esta acción no se puede deshacer.')) {
      const result = await redeem(rewardId);
      if (result.success) {
        alert('¡Beneficio redimido con éxito!');
        refetch(); // Refresh rewards list
      } else {
        alert('Error al redimir el beneficio: ' + result.error);
      }
    }
  };
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3141">
      <div className="p-6 max-w-3xl mx-auto space-y-6" data-id="element-3142">
        <div data-id="element-3143">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3144">
            Redimir Beneficios
          </h1>
          <p className="text-gray-500" data-id="element-3145">
            Busca a un cliente por su número de teléfono para ver y redimir sus
            beneficios.
          </p>
        </div>

        <Card className="p-6" data-id="element-3146">
          <form onSubmit={handleSearch} className="flex gap-3" data-id="element-3147">
            <div className="flex-1" data-id="element-3148">
              <Input type="tel" placeholder="Número de teléfono (ej. 88888888)" value={phoneSearch} onChange={e => setPhoneSearch(e.target.value)} className="w-full" data-id="element-3149" />
            </div>
            <Button type="submit" disabled={phoneSearch.length < 8} data-id="element-3150">
              <Search className="w-4 h-4 mr-2" data-id="element-3151" />
              Buscar
            </Button>
          </form>
        </Card>

        {activePhone && <div className="space-y-6" data-id="element-3152">
            {customerLoading || rewardsLoading ? <div className="text-center py-12 text-gray-500" data-id="element-3153">
                Buscando información...
              </div> : !customer ? <Card className="p-12 text-center" data-id="element-3154">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-3155">
                  <Search className="w-8 h-8 text-gray-400" data-id="element-3156" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-3157">
                  Cliente no encontrado
                </h3>
                <p className="text-gray-500" data-id="element-3158">
                  No hay ningún cliente registrado con el número {activePhone}.
                </p>
              </Card> : <>
                <Card className="p-6 bg-brand-charcoal text-white" data-id="element-3159">
                  <div className="flex items-center gap-4" data-id="element-3160">
                    <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center text-2xl font-bold" data-id="element-3161">
                      {customer.name ? customer.name.charAt(0).toUpperCase() : '?'}
                    </div>
                    <div data-id="element-3162">
                      <h2 className="text-xl font-bold" data-id="element-3163">
                        {customer.name || 'Cliente sin nombre'}
                      </h2>
                      <p className="text-white/70" data-id="element-3164">{customer.phone}</p>
                    </div>
                  </div>
                </Card>

                <div data-id="element-3165">
                  <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-3166">
                    <Gift className="w-5 h-5 text-brand-charcoal" data-id="element-3167" />
                    Beneficios Disponibles ({rewards.length})
                  </h3>

                  {rewards.length === 0 ? <Card className="p-8 text-center text-gray-500" data-id="element-3168">
                      Este cliente no tiene beneficios disponibles en este
                      momento.
                    </Card> : <div className="grid gap-4" data-id="element-3169">
                      {rewards.map(reward => <Card key={reward.id} className="p-4 flex items-center justify-between gap-4 border-l-4 border-l-brand-charcoal" data-id="element-3170">
                          <div data-id="element-3171">
                            <h4 className="font-bold text-gray-900 text-lg" data-id="element-3172">
                              {reward.reward_name}
                            </h4>
                            <p className="text-sm text-gray-500" data-id="element-3173">
                              Válido hasta:{' '}
                              {new Date(reward.expires_at).toLocaleDateString()}
                            </p>
                          </div>
                          <Button onClick={() => handleRedeem(reward.id)} disabled={redeeming} data-id="element-3174">
                            Redimir
                          </Button>
                        </Card>)}
                    </div>}
                </div>
              </>}
          </div>}
      </div>
    </AdminLayout>;
}